module.exports = __webpack_public_path__ + "static/media/uttam.d53d0765.jpeg";